import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import { NestApiProvider } from '../../nest-api';


@Injectable()
export class CompetencyApiProvider {

  private _service: string = '';
  private _model: string = 'sf6s/competency';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public listing(empId: string, language: string): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'listing';
    const _params: any = {};
    const _urlParams: any = {empId : empId, language : language};
    const _body: any = {};

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _func, _params, _body);
  }

  public save(params: any): Observable<any> {
    const _method: string = 'POST';
    const _func: string = 'save';
    const _params: any = params || {};
    const _urlParams: any = {};
    const _body: any = {};

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }

  public delete(params: any): Observable<any> {
    const _method: string = 'POST';
    const _func: string = 'delete';
    const _params: any = params || {};
    const _urlParams: any = {};
    const _body: any = {};

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-integrated/services/profile-competency.api.ts